import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
  OnInit
} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-rich-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrls: ['./rich-text-editor.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => RichTextEditorComponent),
      }
    ]
})
export class RichTextEditorComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() invalidInput: boolean;
  @Input() placeholder: string;
  @Output() valueChangedEvent = new EventEmitter<any>();
  input: string;
  htmlContent = '';
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['textColor'],
      ['backgroundColor'],
      ['link'],
      ['unlink'],
      ['insertImage'],
      ['insertVideo'],
      ['insertHorizontalRule'],
      ['removeFormat'],
    ],
  };

  ngOnInit() {
    this.config.placeholder = this.placeholder;
  }

  valueChanged(value: any) {
    this.onChange(value);
    this.onTouch();
  }

  onChange: any = () => {};
  onTouch: any = () => {};
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(input: string) {
    this.input = input;
  }
}
